import React, { useRef, useState } from 'react';

const MAX_SIZE_BYTES = 50 * 1024 * 1024; // 50MB
const ACCEPT = 'video/*';

export interface ReelUploadProps {
  onSelect: (file: File) => void;
  loading?: boolean;
  error?: string | null;
  disabled?: boolean;
  className?: string;
}

/**
 * Video file picker with 50MB client-side size check. Calls onSelect with the file (caller posts to POST /api/reels).
 */
const ReelUpload: React.FC<ReelUploadProps> = ({
  onSelect,
  loading = false,
  error: externalError = null,
  disabled = false,
  className = '',
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [sizeError, setSizeError] = useState<string | null>(null);
  const error = externalError ?? sizeError;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    setSizeError(null);
    if (!file) return;
    if (file.size > MAX_SIZE_BYTES) {
      setSizeError('Video en fazla 50MB olabilir.');
      e.target.value = '';
      return;
    }
    onSelect(file);
    e.target.value = '';
  };

  const handleClick = () => {
    if (disabled || loading) return;
    inputRef.current?.click();
  };

  return (
    <div className={className}>
      <input
        ref={inputRef}
        type="file"
        accept={ACCEPT}
        onChange={handleChange}
        style={{ display: 'none' }}
      />
      <button
        type="button"
        className="btn btn-primary"
        onClick={handleClick}
        disabled={disabled || loading}
      >
        {loading ? (
          <>
            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
            Yükleniyor...
          </>
        ) : (
          <>
            <i className="fas fa-cloud-upload-alt me-2" />
            Reel Yükle
          </>
        )}
      </button>
      {error && (
        <div className="text-danger small mt-1">{error}</div>
      )}
    </div>
  );
};

export default ReelUpload;
export { MAX_SIZE_BYTES };
